import * as React from "react";

import { ServicesContext } from "./ServicesProvider";

export const useServicesState = () => {
  return React.useContext(ServicesContext);
};
